<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <GroupConfiguration
        :class="$style.groupConfiguration"
        :groupNameInputDisabled="isManagedByActiveDirectory"
        :parentType="parentType"
      >
        <AdminSudoInput
          :parentType="parentType"
        />
        <PosixGroupInput
          :parentType="parentType"
        />
        <SambaAuthenticationInput
          :parentType="parentType"
        />
      </GroupConfiguration>
      <UserGroupCustomUserAttributes
        :parentType="parentType"
      />
    </template>
  </DetailsAsideLayout>
</template>
<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapGetters } from 'vuex';
import AdminSudoInput from 'client/groups/User/AdminSudoInput.vue';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';
import GroupConfiguration from 'client/groups/Components/GroupConfiguration.vue';
import PosixGroupInput from 'client/groups/User/PosixGroupInput.vue';
import SambaAuthenticationInput from 'client/groups/User/SambaAuthenticationInput.vue';
import UserGroupCustomUserAttributes from 'client/groups/User/UserGroupCustomUserAttributes.vue';

const userGroupModel = StoreModelMap[ItemTypeConsts.userGroup];

export default {
  name: 'UserGroupDetails',

  inject: ['$validator'],

  components: {
    AdminSudoInput,
    DetailsAsideLayout,
    GroupConfiguration,
    PosixGroupInput,
    SambaAuthenticationInput,
    UserGroupCustomUserAttributes,
  },

  data() {
    return {
      parentType: ItemTypeConsts.userGroup,
    };
  },

  computed: {
    ...mapGetters(userGroupModel, [
      'item',
      'isManagedByActiveDirectory',
    ]),
  },
};
</script>
<style module>
.groupConfiguration {
  min-height: 300px;
}
</style>
